
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 612 612"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M306 534.75c-11.666 0-23.142-.688-34.465-1.83L115.375 611V475.999C45.721 427.124 1 352.093 1 267.875 1 120.483 137.564 1 306 1c168.437 0 305 119.483 305 266.875S474.437 534.75 306 534.75zm0-495.625c-147.392 0-266.875 102.404-266.875 228.75 0 82.883 51.583 155.207 128.52 195.353L153.5 458.5v95.313l114.375-57.149-12.924-4.309c16.546 2.745 33.587 4.271 51.049 4.271 147.392 0 266.875-102.403 266.875-228.75S453.392 39.125 306 39.125zm84.351 263.853c-12.647 0-22.9-10.248-22.9-22.889s10.253-22.889 22.9-22.889 22.9 10.248 22.9 22.889-10.253 22.889-22.9 22.889zm-85.698 0c-12.648 0-22.901-10.248-22.901-22.889s10.253-22.889 22.901-22.889c12.647 0 22.901 10.248 22.901 22.889s-10.254 22.889-22.901 22.889zm-83.004 0c-12.648 0-22.9-10.248-22.9-22.889s10.252-22.889 22.9-22.889 22.901 10.248 22.901 22.889-10.253 22.889-22.901 22.889z"}})])
          )
        }
      }
    